// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// ⚡ Config de ton projet Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDE0VFPAt6xv0qCme-eYB-v6seUti5r50s",
  authDomain: "unlimited-session.firebaseapp.com",
  projectId: "unlimited-session",
  storageBucket: "unlimited-session.appspot.com",
  messagingSenderId: "312829728838",
  appId: "1:312829728838:web:c9b24251744ddefdb5d247",
  measurementId: "G-RPTCY2H73W"
};

// ⚡ Initialisation Firebase
const app = initializeApp(firebaseConfig);

// 🔐 Authentification
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

// ☁️ Firestore (base de données)
export const db = getFirestore(app);

// 📂 Storage (images / vidéos / fichiers)
export const storage = getStorage(app);

export default app;